import { memo } from "react";
import Button from "../button/Button";
import type { IconName } from "@/components/icons/icons";

export interface LinkButtonProps {
  label: string;
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  onClick?: (() => void) | ((data: any) => void);
  icon?: IconName;
  iconPosition?: "left" | "right";
  width?: string;
}

const LinkButton = ({
  label,
  size,
  disabled = false,
  onClick = () => {},
  icon,
  iconPosition,
  width,
}: LinkButtonProps) => {
  return (
    <Button
      label={label}
      size={size}
      type="link"
      width={width}
      icon={icon}
      iconPosition={iconPosition}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default memo(LinkButton);
